export const SET_LOADING = 'SET_LOADING';

function setLoading(loading, tip) {
    return {
        type: SET_LOADING,
        loading,
        tip,
    };
}

export default setLoading;
